'use client';
import Image from 'next/image';
import Button from '@/components/ui/Button';
import Link from 'next/link';

const CollaboratorsSection = () => {
  const collaborators = [
    
    {
      id: 1,
      src: "/images/globalblockchainshow-logo.svg",
      alt: "Global Blockchain Show",
      link: "https://www.globalblockchainshow.com/",
    },
    {
      id: 2,
      src: "/images/globalaishow-logo.svg",
      alt: "Global AI Show",
      link: "https://www.globalaishow.com/",
    },
    {
      id: 3,
      src: "/images/rework.webp",
      alt: "rework",
      link: "https://ny-ai-finance.re-work.co/",
    },
    {
      id: 4,
      src: "/images/corinium.webp",
      alt: "Corinium",
      link: "https://cdaofs.coriniumintelligence.com/",
    },

  ];

  

  return (
    <section data-component-id="src/app/PartnerSection.tsx:39:4" data-component-path="src/app/PartnerSection.tsx" data-component-line="39" data-component-end-line="75" data-component-file="PartnerSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22partners%22%2C%22className%22%3A%22w-full%20px-4%20sm%3Apx-6%20lg%3Apx-8%20mt-%5B47px%5D%20sm%3Amt-%5B70px%5D%20lg%3Amt-%5B14px%5D%22%7D" id='partners' className="w-full px-4 sm:px-6 lg:px-8 mt-[47px] sm:mt-[70px] lg:mt-[14px]">
      <div data-component-id="src/app/PartnerSection.tsx:40:6" data-component-path="src/app/PartnerSection.tsx" data-component-line="40" data-component-end-line="74" data-component-file="PartnerSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-%5B1280px%5D%20mx-auto%22%7D" className="max-w-[1280px] mx-auto">

        {/* Section Heading */}
        <div data-component-id="src/app/PartnerSection.tsx:43:8" data-component-path="src/app/PartnerSection.tsx" data-component-line="43" data-component-end-line="49" data-component-file="PartnerSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20justify-center%20mb-6%22%7D" className="flex justify-center mb-6">
          <div data-component-id="src/app/PartnerSection.tsx:44:10" data-component-path="src/app/PartnerSection.tsx" data-component-line="44" data-component-end-line="48" data-component-file="PartnerSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20gap-2%20items-center%20bg-%5B%231d1d1d%5D%20rounded-%5B12px%5D%20px-4%20py-2%22%7D" className="flex gap-2 items-center bg-[#1d1d1d] rounded-[12px] px-4 py-2">
            <div data-component-id="src/app/PartnerSection.tsx:45:12" data-component-path="src/app/PartnerSection.tsx" data-component-line="45" data-component-end-line="45" data-component-file="PartnerSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-2%20h-2%20bg-%5B%2327a6b8%5D%20rounded-sm%22%7D" className="w-2 h-2 bg-[#27a6b8] rounded-sm" />
            <p data-component-id="src/app/PartnerSection.tsx:46:12" data-component-path="src/app/PartnerSection.tsx" data-component-line="46" data-component-end-line="46" data-component-file="PartnerSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-white%20text-base%20sm%3Atext-lg%20lg%3Atext-xl%22%2C%22textContent%22%3A%22Past%20Partners%20%26%20Collaborators%22%7D" className="text-white text-base sm:text-lg lg:text-xl">Past Partners & Collaborators</p>
            <div data-component-id="src/app/PartnerSection.tsx:47:12" data-component-path="src/app/PartnerSection.tsx" data-component-line="47" data-component-end-line="47" data-component-file="PartnerSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-2%20h-2%20bg-%5B%2327a6b8%5D%20rounded-sm%22%7D" className="w-2 h-2 bg-[#27a6b8] rounded-sm" />
          </div>
        </div>

        {/* Grid of Logos */}
        <div data-component-id="src/app/PartnerSection.tsx:52:8" data-component-path="src/app/PartnerSection.tsx" data-component-line="52" data-component-end-line="71" data-component-file="PartnerSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20lg%3Agrid-cols-4%20gap-4%20sm%3Agap-6%20lg%3Agap-6%22%7D" className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-6">
          {collaborators.map((item) => (
            <a data-component-id="src/app/PartnerSection.tsx:54:12" data-component-path="src/app/PartnerSection.tsx" data-component-line="54" data-component-end-line="69" data-component-file="PartnerSection.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22className%22%3A%22block%22%7D"
              key={item.id}
              href={item.link}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="block"
            >
              <Image data-component-id="src/app/PartnerSection.tsx:61:14" data-component-path="src/app/PartnerSection.tsx" data-component-line="61" data-component-end-line="68" data-component-file="PartnerSection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22w-full%20h-%5B150px%5D%20sm%3Ah-%5B200px%5D%20lg%3Ah-%5B90px%5D%20object-contain%20rounded-%5B16px%5D%20bg-white%20p-2%22%7D"
                src={item.src}
                alt={item.alt}
                width={532}
                height={274}
                className="w-full h-[150px] sm:h-[200px] lg:h-[90px] object-contain rounded-[16px] bg-white p-2"
                unoptimized
              />
            </a>
          ))}
        </div>

       
      </div>
    </section>
  );
};

export default CollaboratorsSection;
